import CheckIcon from "@mui/icons-material/Check";
import React from "react";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { FeaturesMessages } from "@/messages/platforms/talk2PayConnection/featuresMessages";

interface Props {
  messages: FeaturesMessages;
}

export function Features({ messages }: Props) {
  const featureTexts = [
    messages.featuresText3,
    messages.featuresText4,
    messages.featuresText5,
    messages.featuresText6,
  ];

  return (
    <MDBox>
      <MDBox width="82%" textAlign="center" mx="auto" my={4}>
        <MDBox mb={1}>
          <MDTypography variant="h5" fontWeight="regular">
            {messages.featuresText1}
          </MDTypography>
        </MDBox>
        <MDTypography variant="body2" color="text">
          {messages.featuresText2}
        </MDTypography>

        {featureTexts.map((text, index) => (
          <MDBox display="flex" alignItems="center" mt={2} mb={2} key={index}>
            <CheckIcon color="success" sx={{ mr: 1 }} />
            <MDTypography variant="body2" color="text">
              {text}
            </MDTypography>
          </MDBox>
        ))}
      </MDBox>
    </MDBox>
  );
}
